import React from "react";
import PrintSafesMain from "../../Safes/PrintSafesMain";
import { Dialog } from "@material-ui/core";

export default function RevAccounting(props) {
    const { dataPrint, closePrint, infoPrint } = props;
    const num = dataPrint?.isConfirem ? 6 : 4;
    return (
        <Dialog
            fullScreen
            open={infoPrint}
            onClose={closePrint}
        >
            <div>
                <PrintSafesMain typePrint={num} docNamePdf={"AccountsReport.pdf"} docName={"AccountsReport"}
                    dataPrint={dataPrint} closePrint={closePrint} />
            </div>
        </Dialog>
    );
}
